import React from 'react';
import CustomServiceCard from "./CustomServiceCard";
import {Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from "@mui/material";
import {info, colors, whatsappPhone} from "../../info/Info";
import {trackWhatsAppPopup, trackServiceInteraction} from "../../analytics";

export default function About({darkMode}) {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedService, setSelectedService] = React.useState('');
    
    const handleServiceClick = (serviceName) => {
        setSelectedService(serviceName);
        setOpenDialog(true);
        trackServiceInteraction(serviceName, 'click');
        trackWhatsAppPopup('open', serviceName);
    }

    const handleCancel = () => {
        trackWhatsAppPopup('cancel', selectedService);
        setOpenDialog(false);
    }

    const handleConfirm = () => {
        trackWhatsAppPopup('confirm', selectedService);
        setOpenDialog(false);
        const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappPhone}`;
        window.open(whatsappLink, '_blank');
    }

    return (
        <>
            <Box display={'flex'} width={'100%'} flexDirection={{xs: 'column', s: 'column', md: 'row', }} justifyContent={'center'} mt={ {xs: '3rem', md: '7rem'}}>
                 <CustomServiceCard imagesrc={require('../../img/constelacao.png')} title={info.services[0].title} description={info.services[0].description}  titleColor={colors[1]} clickAction={() => handleServiceClick(info.services[0].title)}/>
                 <CustomServiceCard imagesrc={require('../../img/psico.png')} title={info.services[1].title} description={info.services[1].description}  titleColor={colors[1]} clickAction={() => handleServiceClick(info.services[1].title)}/>
                 <CustomServiceCard imagesrc={require('../../img/atendimento.png')} title={info.services[2].title} description={info.services[2].description} titleColor={colors[1]} clickAction={() => handleServiceClick(info.services[2].title)}/>
            </Box>

            <Dialog
                open={openDialog}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '15px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" style={{fontWeight: 'bold', fontSize: '1.5rem'}}>
                    {"Agende sua sessão"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{fontSize: '1.1rem', color: darkMode ? '#fff' : '#333'}}>
                        Entre em contato pelo WhatsApp para mais informações e para agendar sua sessão. Estou à disposição para ajudá-la!
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{padding: '10px 20px 20px'}}>
                    <Button onClick={handleCancel} style={{color: '#666', fontWeight: 'bold'}}>
                        Cancelar
                    </Button>
                    <Button 
                        onClick={handleConfirm} 
                        variant="contained"
                        style={{
                            backgroundColor: colors[0],
                            color: '#fff',
                            fontWeight: 'bold',
                            padding: '8px 24px',
                            borderRadius: '8px'
                        }}
                        autoFocus
                    >
                        Ir para WhatsApp
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}